"use strict";

const MeticulousPort = {
  add: function (app) {
    app.ports.meticulousRecordContext.subscribe(function (context) {
      const ctx = window.Meticulous?.context;
      if (!ctx) return;

      ctx.recordUserId?.(context.userId);
      ctx.recordUserEmail?.(context.userEmail);
      ctx.recordCustomContext?.("practiceId", context.practiceId);
    });
  },
};

module.exports = MeticulousPort;
